import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShouldPreviewService {

  private shouldPreview = false;

  reset() {
    this.shouldPreview = true;
  }

  get() {
    if (this.shouldPreview) {
      this.shouldPreview = false;
      return true;
    }
    return false;
  }

}
